export default __webpack_public_path__ + "static/media/34k.d7a67669.md";